module.exports = __webpack_public_path__ + "media/src/images/placeholder-image-0553c4e574adfa824381a36f3b5f5635.png";